import React from 'react';
import { SeoHead } from '../components/SeoHead';
import { getStaticPageMetadata } from '../lib/seo';
import { PageContainer } from '../src/components/ui/page-container';

const ContactPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-surface-canvas flex flex-col">
            <SeoHead meta={getStaticPageMetadata('/contact')!} />
            <div className="h-header flex-shrink-0" />

            <main id="main-content" className="flex-grow text-text-primary">
                <PageContainer size="narrow" className="py-16">
                    <h1 className="text-3xl font-semibold text-brand-primary mb-8">Contact Us</h1>
                    <div className="prose max-w-none text-text-primary leading-relaxed space-y-4">
                        <p>Martial Arts Network welcomes general enquiries and feedback, whether that is a question about the platform, a problem with your account or something else you would like to raise.</p>
                        <p>Email us at <a href="mailto:contact@martialartnetwork.com.au" className="text-brand-primary underline underline-offset-2 hover:no-underline">contact@martialartnetwork.com.au</a></p>
                        <p>Every message is read. We reply as quickly as we can, though response times vary depending on the enquiry.</p>
                    </div>
                </PageContainer>
            </main>

        </div>
    );
};

export default ContactPage;
